import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-21 16:56:34
 * @LastEditTime: 2022-04-21 16:56:35
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\recordManage\request.js
 */
import request from '@/utils/request';

// 理赔记录
export function claimsList(data) {
  return request.post('admin/claims/list', data);
}
// 理赔详情
export function claimsDetail(data) {
  return request.post('admin/claims/detail', data).then(res => {
    console.log(res.claimsInfo);
    res.claimsInfo.claimsDocument.map(i2 => {
      i2.documentUrl.map((i, index) => {
        i.status = 'done';
        i.uid = index + 1;
        return i;
      });
      return i2;
    });
    return res;
  });
}